// ========= IMPORTS =========
import React from "react";

/** @jsx jsx */
import { jsx, css } from "@emotion/core";

const cardStyleBase = css`
	display: flex;
	justify-content: center;
	align-items: center;

	color: white;
	font-family: LunchBox;
	text-align: center;
	text-transform: uppercase;

	padding: 0.5rem;
	border-radius: 3px;
`;

export const Card = ({ color, info, triggerModal, position, cardStatus, setCardStatus }) => {
	const show = cardStatus[position[0]][position[1]];
	return (
		<div
			onClick={() => {
				if (show) {
					triggerModal(info);

					const updatedStatus = [...cardStatus];
					updatedStatus[position[0]][position[1]] = false;
					setCardStatus(updatedStatus);
				}
			}}
			css={[
				cardStyleBase,
				css`
					cursor: pointer;
					background-color: ${show ? color : `silver`};
					font-size: 1.75em;
					opacity: 0.75;
				`,
			]}
		>
			{show && `$${info.cashPrize}`}
		</div>
	);
};

export const HeaderCard = ({ color, header }) => (
	<div
		css={[
			cardStyleBase,
			css`
				font-size: 1.5rem;
				background-color: ${color};
			`,
		]}
	>
		{header}
	</div>
);
